/**
 * GulfBridge brand mark. Renders the logo image + wordmark.
 *
 * Default: logo mark + "GulfBridge" wordmark visible at every viewport (including
 * mobile portrait). Pass `hideWordmark` to render the mark only.
 */
export function Logo({
    size = 'md',           // 'sm' | 'md' | 'lg' | 'xl'
    forceWordmark = false, // retained for back-compat — wordmark is shown by default now
    hideWordmark = false,  // hide wordmark on all sizes (logo-only)
    className = '',
    'data-testid': testId = 'logo',
}) {
    const dims = {
        sm: { mark: 'w-6 h-6', text: 'text-sm' },
        md: { mark: 'w-8 h-8', text: 'text-lg' },
        lg: { mark: 'w-12 h-12', text: 'text-xl' },
        xl: { mark: 'w-20 h-20', text: 'text-2xl' },
    }[size];

    // Wordmark visibility logic:
    //   hideWordmark → never show
    //   otherwise   → always show (including mobile portrait)
    // `forceWordmark` is now equivalent to the default; kept as a no-op for callers that pass it.
    void forceWordmark;
    const wordmarkVisibility = hideWordmark ? 'hidden' : 'inline';

    return (
        <span className={`inline-flex items-center gap-2 ${className}`} data-testid={testId}>
            <img
                src="/gulfbridge-logo.png"
                alt="GulfBridge"
                className={`${dims.mark} object-contain shrink-0`}
                loading="eager"
                decoding="async"
                draggable="false"
            />
            <span className={`font-heading ${dims.text} font-black tracking-tight ${wordmarkVisibility}`}>
                GulfBridge
            </span>
        </span>
    );
}

export default Logo;
